define('bundles/appStore',['require','bundles/common-ui','root/app_store/Podio.UI.AppStore.SharesView','root/app_store/Podio.UI.AppStore.InstallShare','root/app_store/Podio.UI.AppStore.NewEditShare','root/app_store/Podio.UI.AppStore.Permalink'],function(require) {

  require('bundles/common-ui');

  require('root/app_store/Podio.UI.AppStore.SharesView');
  require('root/app_store/Podio.UI.AppStore.InstallShare');
  require('root/app_store/Podio.UI.AppStore.NewEditShare');
  require('root/app_store/Podio.UI.AppStore.Permalink');

});

